<template>
    <div class="preview">
        <PreviewComponent />
    </div>
</template>

<script>
import PreviewComponent from "@/components/preview/PreviewComponent.vue";

export default {
    name: "Preview",
    components: {
        PreviewComponent
    }
};
</script>
